<template>
    <div class="uk-width-medium-1-5 uk-width-mid-1-5  uk-width-small-1-1 leftnav">    
        <!--导航-->     
   <!--      <div class="ipp-text-white merchant_top uk-hidden-small  ipp-rel" v-if="currentMerchant" >
            <span class="ipp-icon ipp-icon-type-shop"></span> <span class="merchant_name"></span>
        </div> -->

        <nav class="uk-navbar uk-hidden-small " >           
            <ul class="uk-nav uk-nav-offcanvas ">  
                <li v-for="(item,index) in routes" v-if="(!item.hidden && !item.hasOwnProperty('is_super')) || (!item.hidden && item.is_super && userInfo.parent_account == 0)" :class=" item.name.indexOf(currname) > -1 ? 'uk-active' : ''">
                    <a  @click="goRouter(item.redirect);" >
                       <span class="uk-margin-right ipp-icon uk-margin-right" :class="'ipp-icon-'+item.icon" ></span> {{ $t('menu.'+item.children[0].meta.title) }} 
                    </a>
                </li>
            </ul>
        </nav>
        

       


        <!--end-->
        <!--主体end-->
        <div id="offcanvas" class="uk-offcanvas">
            <div class="uk-offcanvas-bar ">
                <ul class="uk-nav  uk-nav-offcanvas uk-nav-parent-icon uk-margin-large-top ipp-navbar-nav" data-uk-nav="">
                    <li v-for="(item,index) in routes" v-if="(!item.hidden && !item.hasOwnProperty('is_super')) || (!item.hidden && item.is_super && userInfo.parent_account == 0)" :class=" item.name.indexOf(currname) > -1 ? 'uk-active' : ''">
                        <a  @click="goRouter(item.redirect);" >
                           {{ $t('menu.'+item.children[0].meta.title) }} 
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 语言切换 -->
        <!-- <div id="changeLang" class="uk-offcanvas">
            <div class="uk-offcanvas-bar uk-offcanvas-bar-flip">
                <ul class="uk-nav  uk-nav-offcanvas uk-nav-parent-icon uk-margin-large-top ipp-navbar-nav" data-uk-nav="">
                    <li :class="language == 'EN' ? 'uk-active' : ''"><a @click="langEn">English</a></li>
                    <li :class="language == 'CN' ? 'uk-active' : ''"><a @click="langCn">中文</a></li>
                </ul>
            </div>
        </div> -->
    </div>
</template>
<script>
import system from '@/components/common/resouces/system'
export default {
    name: 'leftnav',
    data() {
        return {
            currname: '',
            language: '',                   
        }
    },
    created() {
        let token = localStorage.getItem("access_token");
        if (!token) {
            this.$router.push({
                path: '/login',
            });
        }

       

    },
    computed:{
        userInfo(){
          return this.$store.state.home.userInfo
        },

        institutionInfo(){
          return this.$store.state.home.institutionInfo
        },
        currentMerchant(){
            return this.$store.state.home.current_merchant; 
        },

        routes(){
            return this.$router.options.routes
        },

        
        flag(){
          return this.$store.state.home.flag
        }
        
    },
    mounted: function() {
        let matched = this.$route
        this.currname = matched.name


        // console.log(this.$route)        

        $('body').attr('class', '');
        $('body').attr('style', '');
        // let name = this.$route.path
        // this.currname = name
        if (this.$i18n.locale == 'en-us') {
            this.language = 'EN'
        } else {
            this.language = 'CN'
        }
        // var d = new Date();
        // if (name == '' || name == 'index') {
        //     this.$store.dispatch('closeLoading', 1);
        // } else {
        //     this.$store.dispatch('closeLoading', 0);
        // }
          
    },
    activated:function(){      
        

    },
    methods: {
        goRouter(route){      
            if(this.userInfo.is_bind_secret == 0){
                this.$router.replace('/Error/need_bind');
                return
            }else{                                            
                this.jump(route);
            }
        },

        jump(route){

            var no = localStorage.getItem("current_merchant_no");
            if(no){
                this.$router.push({
                    path:route,                
                })
            }else{
                 this.$router.push({
                    path:'/Merchant/create_merchant',                
                })
            }

            
            this.defaultClose();
        },

        
        //切换英文
        langEn() {
            this.$i18n.locale = 'en-us'
            window.localStorage.setItem('language', 'en-us');
            this.language = 'EN'
            // console.log(this.language)
            this.defaultClose();
            // console.log(this.currname)
            this.changeLang(this.$i18n.locale)
            // this.setTitle(this.$i18n.locale);
        },
        //切换中文
        langCn() {
            this.$i18n.locale = 'zh-cn'
            window.localStorage.setItem('language', 'zh-cn');
            this.language = 'CN'
            // console.log(this.language)
            this.defaultClose();
            // console.log(this.currname)
            this.changeLang(this.$i18n.locale)
            // this.setTitle(this.$i18n.locale);
        },
        defaultClose() {
            $.UIkit.offcanvas.hide();
        },
        changeLang(v){
            // if (this.currname == 'index' ||  this.currname == 'setting') {
            //     this.$parent.chooseLang();
            // }
            // if (this.currname == 'setting') {
            //     this.$parent.changPay();
            // }
        },
        

    },
    watch:{
        $route(newVal){
            this.currname = newVal.name
        }
    }


}
</script>


// WEBPACK FOOTER //
// src/components/common/leftnav.vue